<template>
  <div>
    <v-card>
      <v-card-title>
      <v-icon color="primary">
        mdi-credit-card-outline
      </v-icon>
        <span class="pl-2">{{ $t('ops.schoolPayments.title') }}</span>
        <v-spacer></v-spacer>
        <v-chip color="primary" text-color="white" class="mr-2">
          {{ $t('ops.schoolPayments.total', { amount: totalPaid }) }}
        </v-chip>
      </v-card-title>
      <v-data-table
        item-key="id"
        :loading="isLoading"
        :loading-text="$t('ops.schoolPayments.loadingText')"
        :headers="headers"
        :items="payments"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('common.search')"
            class="mx-4"
          ></v-text-field>
        </template>

        <template v-slot:item.payment_date="{ item }">
          {{ item.payment_date | moment("LL") }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      payments: [],
      totalPaid: 0,
      isLoading: false,
      search: "",
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('ops.schoolPayments.headers.id'), value: "id", align: "start", filterable: false },
        { text: this.$t('ops.schoolPayments.headers.plan'), value: "plan_name" },
        { text: this.$t('ops.schoolPayments.headers.price'), value: "price" },
        { text: this.$t('ops.schoolPayments.headers.coins'), value: "coin_count" },
        { text: this.$t('ops.schoolPayments.headers.date'), value: "payment_date" },
      ];
    },
  },
  mounted() {
    this.loadPayments();
  },
  methods: {
    loadPayments() {
      this.isLoading = true;
      this.payments = [];
      axios
        .get(`/charges/school`)
        .then((response) => {
          this.payments = response.data.charges;
          this.totalPaid = response.data.totalPaid;
        })
        .catch((error) => {
          this.$notify({
            title: this.$t('common.error'),
            text: this.$t('ops.schoolPayments.fetchError'),
            type: "error",
          });
          console.log(error);
          this.$swal(this.$t('common.error'), error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    viewUpcomingPayment(payment)
    {
      this.$router.push({
        name: "view-upcoming-payment",
        params: {
          user_id: payment.id,
        },
      });
    },
    redeemPayment(index) {
      this.$swal({
        title: this.$t('ops.schoolPayments.redeemTitle'),
        html: this.$t('ops.schoolPayments.redeemConfirm', { amount: this.payments[index].total_amount, name: this.payments[index].user_name }) + " <br/><br/>" +
        this.showRedemptionDetails(index),
        icon: "warning",
        footer: this.showRedemptionFooter(index),
        showCancelButton: true,
        confirmButtonText: this.$t('ops.schoolPayments.redeemConfirmButton'),
      }).then((result) => {
        if (result.isConfirmed) {
          this.redeemPaymentServer(this.payments[index].id, index);
        }
      });
    },

    showRedemptionFooter(index)
    {
      let redemption_preference = this.payments[index].redemption_preference;
      if(redemption_preference==2)
      {
        return '<h2>' + this.$t('ops.schoolPayments.footerBankAccount') + '</h2>';
      }
      else if(redemption_preference==3)
      {
        return '<h2>PayPal</h2>';
      }
      else if(redemption_preference==4)
      {
        return '<h2>' + this.$t('ops.schoolPayments.footerMobileMoney') + '</h2>';
      }
      else
      {
        return '<h2>' + this.$t('ops.schoolPayments.footerCash') + '</h2>';
      }
    },
    showRedemptionDetails(index)
    {
      let redemption_preference = this.payments[index].redemption_preference;
      console.log(redemption_preference);
      if(redemption_preference==2)
      {
        return '<ul><li><b>' + this.$t('ops.payments.details.bankName') + '</b> ' + this.payments[index].redemption_details.bank_name + '</li>' +
        '<li><b>' + this.$t('ops.payments.details.accountNumber') + '</b> ' + this.payments[index].redemption_details.account_number + '</li>' +
        '<li><b>' + this.$t('ops.payments.details.beneficiaryName') + '</b> ' + this.payments[index].redemption_details.beneficiary_name + '</li>' +
        '<li><b>' + this.$t('ops.payments.details.beneficiaryAddress') + '</b> ' + this.payments[index].redemption_details.beneficiary_address + '</li>' +
        (this.payments[index].redemption_details.iban != null ? '<li><b>' + this.$t('ops.payments.details.iban') + '</b> ' + this.payments[index].redemption_details.iban + '</li>' : '') +
        (this.payments[index].redemption_details.swift != null ? '<li><b>' + this.$t('ops.payments.details.swift') + '</b> ' + this.payments[index].redemption_details.swift + '</li>' : '') +
        (this.payments[index].redemption_details.routing_number != null ? '<li><b>' + this.$t('ops.payments.details.routingNumber') + '</b> ' + this.payments[index].redemption_details.routing_number + '</li>' : '') +
        (this.payments[index].redemption_details.bic != null ? '<li><b>' + this.$t('ops.payments.details.bic') + '</b> ' + this.payments[index].redemption_details.bic + '</li>' : '') +
        '</ul>';
      }
      else if(redemption_preference==3)
      {
        return "<b>" + this.$t('ops.payments.details.paypalLabel') + "</b> " + this.payments[index].redemption_details.email;
      }
      else if(redemption_preference==4)
      {
        return '<ul><li><b>' + this.$t('ops.payments.details.phoneNumber') + '</b> ' + this.payments[index].redemption_details.phone_number + '</li>' +
        '<li><b>' + this.$t('ops.payments.details.network') + '</b> ' + this.payments[index].redemption_details.network + '</li>' +
        '<li><b>' + this.$t('ops.payments.details.name') + '</b> ' + this.payments[index].redemption_details.name + '</li>' +
        '</ul>';
      }
      else
      {
        return "";
      }
    },

    redeemPaymentServer(user_id, index) {
      this.isLoading = true;
      axios
        .post(`/users/redeem`, {
          user_id: user_id,
        })
        .then((response) => {
          this.$notify({
            title: this.$t('common.success'),
            text: this.$t('ops.schoolPayments.redeemedSuccess'),
            type: "success",
          });
          this.payments.splice(index, 1);
        })
        .catch((error) => {
          this.$notify({
            title: this.$t('common.error'),
            text: this.$t('ops.schoolPayments.redeemError'),
            type: "error",
          });
          console.log(error);
          this.$swal(this.$t('common.error'), error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover{
  cursor: pointer;
  background: rgba($primary-shade--light, 0.15) !important;
}
</style>
